//修改密码
import modifypassword from '@/components/modifypassword'
//学生信息
import studentInformation from '@/components/studentInformation'
//学生计划
import electiveCourse from '@/components/electiveCourse/js'
//满意度调查
import satisfactionsurvey from '@/components/satisfactionsurvey'

import campusJobRecordList from '../campusJob'
let children=modifypassword
children.push(...studentInformation)
children.push(...electiveCourse)
children.push(...satisfactionsurvey)
children.push(...campusJobRecordList)
export default [
  {
    path: '/',
    name: 'FirstPage',
    component: resolve => require(['@/components/firstPage/FirstPage.vue'], resolve),
    children: children,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/components/firstPage/index.js